import { AuthContext } from "auth-context";
import { Content } from "components/content";
import { MediaLines } from "components/daily-media-line";
import { Iif } from "components/iif";
import { Spacer } from "components/utility-components";
import { IAuthContextProps, withAuthContext } from "components/with-auth-context";
import { TopLineUsageContext } from "model/autogen/TopLineUsageContext";
import { UserLevel } from "model/autogen/UserLevel";
import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { RecentResourcesPage } from "./recent-content-page";

interface IResourcesPageState {

}

const BIG_TITLE = "Top Resource Lines";

class ResourcesLandingPageBase extends React.Component<RouteComponentProps<any> & IAuthContextProps, IResourcesPageState> {
    constructor(props: any) {
        super(props);
    }
    public render() {
        return <>
            <Content>
                <AuthContext.Consumer>
                    {({ methods, state: { user } }) => (<>
                        <Iif show={user.level !== UserLevel.SystemUser}>
                            <MediaLines customBigTitle={BIG_TITLE} context={TopLineUsageContext.Resources} enableEdit={true} showBigTitle={true} isExternal={true} />
                        </Iif>
                        <Spacer />
                        <Iif show={user.level > UserLevel.External}>
                            <MediaLines customBigTitle={BIG_TITLE} context={TopLineUsageContext.Resources} enableEdit={true} showBigTitle={false} isExternal={false} />
                        </Iif>
                    </>)}
                </AuthContext.Consumer>
            </Content>
            <Spacer />
            <RecentResourcesPage />
        </>;
    }
}

export const ResourcesLandingPage = withAuthContext(ResourcesLandingPageBase);


// WEBPACK FOOTER //
// ./src/pages/resources-landing-page.tsx